export const SORT_MENU_DEFAULT_VALUES = {
  sortBy: ['date'],
  sortOrder: ['desc']
}

export const SORT_BY_OPTIONS = [
  {
    label: 'Date',
    value: 'date'
  },
  {
    label: 'Subject',
    value: 'subject'
  }
]

export const SORT_ORDER_OPTIONS = {
  date: [
    {
      label: 'Oldest on top',
      value: 'asc'
    },
    {
      label: 'Newest on top',
      value: 'desc'
    }
  ],
  subject: [
    {
      label: 'A to Z',
      value: 'asc'
    },
    {
      label: 'Z to A',
      value: 'desc'
    }
  ]
}
